import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { RunPackageDialogData } from '@app/shared/components/dialogs/run-package-dialog/run-package-dialog.data';

import { Store } from '@src/store';
import {packagesActions} from '../../../../../store/reducers/packagesReducer';
import { IACOption } from '@src/app/shared/components/dialogs/dbm-autocomplete/dbm-autocomplete.component';



@Component({    
    selector : 'run-package-dialog',
    template: require('./run-package-dialog.component.html'),
    styles: [require('./run-package-dialog.component.scss')]
})
export class RunPackageDialogComponent {
    public requests: any[] = [];
    public reqData: any;
    private searchText: string;
    public packageList: IACOption[] = [];
    private packageLimit = 50;
    
    
    constructor(@Inject(MAT_DIALOG_DATA) public data: RunPackageDialogData, public store : Store) {
        this.reqData = data;

        
    }

    async onReloadPackages () {
                
        var res = await this.store.dispatch({
            type:packagesActions.GET_PACKAGES_BY_WILDCARD_AND_LIMIT,
            payload: { projectId: this.reqData.projectId, wildcard: this.searchText, limit: this.packageLimit }
        });

        this.packageList = [];
        if(res.data)
        {
            res.data.forEach(element => {
                this.packageList.push({id: element.VersionID, name: element.versionString});            
            });
        }
    }

    onACTextChange(text: any): void {
        this.searchText = text; 
        this.data.selectedPackage = null;
    }
    
    onACSelectedOption(data: IACOption): void {        
        this.data.selectedPackage = data;
    }
    

    

  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/run-package-dialog/run-package-dialog.component.ts